export default __webpack_public_path__ + "static/media/Icon metro-pin.aef77690.svg";